module.exports = __webpack_public_path__ + "static/label-a25144b60e2f0f6ee5f3ef58be6cf4c6.png";